import CircleCheck from '@/icons/check-circle.svg';
import { cn } from '@/utils';

function Chip({ className, text, ...props }) {
	return (
		<div
			className={cn(
				'flex h-7 items-center justify-center gap-1 rounded-[38px] bg-green-background px-2 py-1 text-xs font-semibold text-green',
				className
			)}
			{...props}
		>
			<CircleCheck aria-hidden className="size-4 text-green" />
			{text}
		</div>
	);
}

export default Chip;
